import { render, staticRenderFns } from "./episode-card-v2.vue?vue&type=template&id=7a38ab68&scoped=true&"
import script from "./episode-card-v2.vue?vue&type=script&lang=js&"
export * from "./episode-card-v2.vue?vue&type=script&lang=js&"
import style0 from "./episode-card-v2.vue?vue&type=style&index=0&id=7a38ab68&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a38ab68",
  null
  
)

export default component.exports